import { ActionList, Card, Button, ButtonGroup, Modal, Popover, TextField, Text, BlockStack, InlineStack, Banner, DropZone, InlineError, InlineGrid, RadioButton, Checkbox, Divider, Thumbnail, Icon } from '@shopify/polaris';
import { AddMajor, ChevronDownMinor, NoteMinor } from '@shopify/polaris-icons';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { DIProps } from '../../../../Core';
import ReactJson from 'react-json-view';
import { environment } from '../../../../environments/environment'

interface Props extends DIProps {
    selectedRowKeys: any
    activityRefreshAction: () => void
    selectedFlagChild: Array<string>
}

function Adminactions(props: Props) {
    const [openPopover, setopenPopover] = useState<boolean>(false)
    const [feedmodal, setFeedmodal] = useState<boolean>(false)
    const [labelModal, setLabelModal] = useState<boolean>(false);
    const [validateModal, validateFeedModal] = useState<boolean>(false)
    const [text, settext] = useState<string>('')
    const [loaders, setloaders] = useState<any>({
        remove_error_tag: false,
        remove_error_tag_from_all_products: false,
        remove_process_tag: false,
        remove_process_tag_from_all_products: false,
        remove_status: false,
        remove_status_from_all_status: false,
        remove_product_matching_from_amazon: false,
        remove_all_products_matching: false,
        remove_products_from_amazon_listing: false,
        remove_asin: false,
        remove_all_asin: false,
    })
    const [modalData, setmodalData] = useState<any>({
        title: "",
        type: "",
        open: false
    })

    const pageActions = (action: any) => {
        let modal_data = { ...modalData };
        modal_data.open = true;
        modal_data.type = action;
        modal_data.title = action.replace(/_/gi, ' ').replace(/\b\w/g, (c: any) => c.toUpperCase());
        setmodalData(modal_data);
    }

    const feedData = () => {

        setFeedmodal(!feedmodal);

    }

    const ValidateFeed = () => {
        validateFeedModal(!validateModal)

    }

    const bulkLabelAssignment = () => {
        setLabelModal(!labelModal)
    }

    const renderAdminActions = () => {
        const pageActionOptions = [
            { content: 'Remove error tag', id: 'remove_error_tag', onAction: () => pageActions('remove_error_tag') },
            { content: 'Remove process tag', id: 'remove_process_tag', onAction: () => pageActions('remove_process_tag') },
            { content: 'Remove status', id: 'remove_status', onAction: () => pageActions('remove_status') },
            // { content: 'Remove product matching from amazon', id: 'remove_product_matching_from_amazon', onAction: () => pageActions('remove_product_matching_from_amazon') },
            { content: 'Remove products from Amazon listing', id: 'remove_products_from_amazon_listing', onAction: () => pageActions('remove_products_from_amazon_listing') },
            { content: 'Remove asin', id: 'remove_asin', onAction: () => pageActions('remove_asin') },
            { content: 'Remove all Queued Actions', id: 'removeQueuedTaskAction', onAction: () => pageActions('removeQueuedTaskAction') },
            { content: 'View Feed Data', id: 'removeQueuedTaskAction', onAction: feedData },
            { content: 'Validate Feed', id: 'ValidateFeedAction', onAction: ValidateFeed },
            { content: 'Bulk Label Assignment', id: 'bulkLabelAssignment', onAction: bulkLabelAssignment },
        ];
        return <>
            {
                <Popover active={openPopover} onClose={() => setopenPopover(false)} activator={<ButtonGroup variant="segmented">
                    <Button icon={ChevronDownMinor} onClick={() => setopenPopover(!openPopover)}>
                        Admin actions
                    </Button>
                </ButtonGroup>
                } >  <ActionList items={pageActionOptions} /></Popover>
            }
        </>;
    }





    const modalStructure: any = (render = '', exempted = false) => {
        let { selectedRowKeys } = props;
        return (selectedRowKeys.length > 0 || exempted) ? render : <TextField
            label='Note: Since no product is selected, action will be performed for all the products'
            placeholder="Password"
            autoComplete="off"
            onChange={(e: string) => settext(e)}
            value={text}
        />;
    }

    const renderModalStructure: any = () => {

        let { type } = modalData;

        switch (type) {
            case 'remove_error_tag':
                return modalStructure(<TextField
                    autoComplete="off"
                    label="The action will remove the error tag from Activity column of listing grid. The action is irreversible, so proceed accordingly"
                    onChange={(e: string) => settext(e)}
                    value={text}
                    placeholder="Password"
                />);
            case 'remove_process_tag':
                return modalStructure(<TextField
                    autoComplete="off"
                    label="The action will remove the process tag from Activity column of listing grid. The action is irreversible, so proceed accordingly"

                    onChange={(e: string) => settext(e)}
                    value={text}
                    placeholder="Password"
                />);
            case 'remove_status':
                return modalStructure(<TextField
                    autoComplete="off"
                    label="The action will remove the status from Amazon Status column of listing grid. The action is irreversible, so proceed accordingly"

                    onChange={(e: string) => settext(e)}
                    value={text}
                    placeholder="Password"
                />);
            case 'remove_product_matching_from_amazon':
                return modalStructure(<TextField
                    autoComplete="off"
                    label="The action will remove asin and sku from amazon_product_container (remove amazon sku and set shopify sku on product) and remove amazon status.The action is irreversible, so proceed accordingly"
                    onChange={(e: string) => settext(e)}
                    value={text}
                    placeholder="Password"
                />, true);
            case 'remove_products_from_amazon_listing':
                return modalStructure(<TextField
                    autoComplete="off"
                    label="The action will remove products from amazon_listings. To check this , goto Amazon Listings tab in listing section. The action is irreversible, so proceed accordingly"

                    onChange={(e: string) => settext(e)}
                    value={text}
                    placeholder="Password"
                />, true);
            case 'remove_asin':
                return modalStructure(<TextField
                    autoComplete="off"
                    label="The action will remove the asin from amazon_product_container.To check this action result open network tab and check product data. The action is irreversible, so proceed accordingly"

                    onChange={(e: string) => settext(e)}
                    value={text}
                    placeholder="Password"
                />);
            case 'removeQueuedTaskAction':
                return modalStructure(<TextField
                    autoComplete="off"
                    label="The action will remove all queued task's data from queued task.To check this action result open network tab and check product data. The action is irreversible, so proceed accordingly"
                    onChange={(e: string) => settext(e)}
                    value={text}
                    placeholder="Password"
                />);
            default:
                return (
                    <Text as="p" fontWeight="regular">Do you want to proceed ?</Text>
                );
        }
    }


    const performAdminAction = (action: string) => {
        let data: any = {
            "source": {
                "shopId": props?.redux?.current?.source?._id,
                "marketplace": props?.redux?.current?.source?.marketplace
            },
            "target": {
                "shopId": props?.redux?.current?.target?._id,
                "marketplace": props?.redux?.current?.target?.marketplace

            }
        }
        let url: string = "";
        let loading = { ...loaders }
        loading[action] = true

        setloaders(loading)
        switch (action) {
            case "remove_error_tag":
                url = "amazon/request/removeErrorTag"
                break;
            case "remove_error_tag_from_all_products":
                url = "amazon/request/removeErrorTag"
                break;
            case "remove_process_tag":
                url = "amazon/request/removeProcessTag"
                break;
            case "remove_process_tag_from_all_products":
                url = "amazon/request/removeProcessTag"
                break;
            case "remove_status":
                url = "amazon/request/removeStatus"
                break;
            case "remove_status_from_all_status":
                url = "amazon/request/removeStatus"
                break;
            case "remove_product_matching_from_amazon":
                url = "amazon/request/removeProductFromMatching"
                break;
            case "remove_all_products_matching":
                url = "amazon/request/removeProductFromMatching"
                break;
            case "remove_products_from_amazon_listing":
                url = "amazon/request/removeProductFromListing"
                break;
            case "remove_asin":
                url = "amazon/request/removeAsin"
                break;
            case "remove_all_asin":
                url = "amazon/request/removeAsin"
                break;
            case "removeQueuedTaskActions":
                url = "amazon/request/removeQueuedTask"
                break;

        }

        let senddata: any = {
            Password: text
        }

        props.selectedRowKeys.length > 0 ? senddata['source_product_id'] = props.selectedRowKeys : null;
        props.selectedRowKeys.length > 0 ? senddata['isParent'] = true : null;
        if (!senddata['source_product_id']) {
            senddata['source_product_id'] = props.selectedFlagChild
            senddata['isParent'] = false
        }

        data['data'] = senddata;
        let modal_data: any = { ...modalData }
        props.di.POST(url, data).then((response) => {
            modal_data.open = false;
            setmodalData(modal_data);
            let loading = { ...loaders }
            loading[action] = false
            setloaders(loading)
            if (response.success) {
                props.success(response.message)
                setopenPopover(false)
                props.activityRefreshAction()
            } else {
                props.error(response.message)
            }
        })
    }

    const triggerPrimaryAction = () => {
        let { type } = modalData;
        let primaryAction = {};
        switch (type) {
            case 'remove_error_tag':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_error_tag') },
                    loading: loaders.remove_error_tag
                };
                break
            case 'remove_error_tag_from_all_products':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_error_tag_from_all_products') },
                    loading: loaders.remove_error_tag_from_all_products
                };
                break
            case 'remove_process_tag':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_process_tag') },
                    loading: loaders.remove_process_tag
                };
                break
            case 'remove_process_tag_from_all_products':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_process_tag_from_all_products') },
                    loading: loaders.remove_process_tag_from_all_products
                };
                break
            case 'remove_status':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_status') },
                    loading: loaders.remove_status
                };
                break
            case 'remove_status_from_all_status':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_status_from_all_status') },
                    loading: loaders.remove_status_from_all_status
                };
                break
            case 'remove_product_matching_from_amazon':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_product_matching_from_amazon') },
                    loading: loaders.remove_product_matching_from_amazon
                };
                break
            case 'remove_all_products_matching':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_all_products_matching') },
                    loading: loaders.remove_all_products_matching
                };
                break
            case 'remove_products_from_amazon_listing':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_products_from_amazon_listing') },
                    loading: loaders.remove_products_from_amazon_listing
                };
                break
            case 'remove_asin':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_asin') },
                    loading: loaders.remove_asin
                };
                break
            case 'remove_all_asin':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('remove_all_asin') },
                    loading: loaders.remove_all_asin
                };
                break
            case 'removeQueuedTaskAction':
                primaryAction = {
                    content: 'Proceed',
                    onAction: () => { performAdminAction('removeQueuedTaskActions') },
                    loading: loaders.remove_all_asin
                };
                break
            default:
                break;
        }
        return primaryAction;
    }



    return (<>
        {renderAdminActions()}
        {modalData?.open && <Modal
            open={modalData?.open}
            onClose={() => {
                let temp = { ...modalData };
                temp.open = false;
                setmodalData(temp);
            }}
            title={modalData.title}
            primaryAction={triggerPrimaryAction()}
        >
            <Card roundedAbove='sm'>{renderModalStructure()}</Card>
        </Modal>}

        <RenderModal {...props} feedmodal={feedmodal} setFeedmodal={setFeedmodal}></RenderModal>
        <RenderValidateModal {...props} validateModal={validateModal} validateFeedModal={validateFeedModal}></RenderValidateModal>
        <RenderLabelAssignmentModal {...props} labelModal={labelModal} setLabelModal={setLabelModal} />

    </>

    )
}
const RenderValidateModal = React.memo((Props: any) => {
    let { selectedRowKeys } = Props;
    const [container_id, setcontainerId] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const [feedData, setFeedData] = useState<any>()
    const [json_error, setJSONError] = useState<any>()
    useEffect(() => {
        setcontainerId(Props.selectedRowKeys.length > 0 ? Props.selectedRowKeys.toString() : '')
    }, [selectedRowKeys])


    const reset = () => {
        setLoading(false);
        setFeedData(undefined)
        setJSONError(undefined)

    }

    const handleCopyClick = (Data: any) => {
        navigator.clipboard.writeText(Data)
            .then(() => {
                Props.success('Data copied to clipboard!');
            })
            .catch((err) => {
                Props.error("Failed to copy")
                console.error('Failed to copy text: ', err);
            });
    };



    const getValidateFeedResponse = () => {
        if (container_id.length < 0) {
            Props.error("Please provide source product id")
        } else {
            setLoading(true)
            let payload: any = {
                "target": {
                    "marketplace": Props?.redux?.current?.target?.marketplace,
                    "shopId": Props?.redux?.current?.target?.['_id']
                },
                "source": {
                    "marketplace": Props?.redux?.current?.source?.marketplace,
                    "shopId": Props?.redux?.current?.source?.['_id']
                },
                "source_product_ids": container_id.split(","),
                "activePage": 1,
                "return_feed": true,
                "useRefinProduct": true
            };
            // console.log(payload,"payload");
            Props.di.POST("amazon/product/ValidateFeed", payload).then((data: any) => {
                setLoading(false);
                if (data.success) {
                    setFeedData(data?.validation);
                    // setJSONError(data?.jsonProductErrorList)
                } else {
                    // setJSONError(data?.jsonProductErrorList)
                    Props.error(data?.message)
                }

            })
        }


    }
    return (
        <Modal
            open={Props?.validateModal}
            onClose={() => {
                reset()
                Props.validateFeedModal(false);
            }}
            title={"Validate Feed Data"}
            primaryAction={{
                content: 'Proceed',
                onAction: () => getValidateFeedResponse(),
                loading: loading
            }}
        >
            <Card roundedAbove='sm'>
                <BlockStack gap={'300'}>
                    <TextField placeholder='source product id' autoComplete="off" label='Provide source product id ' value={container_id} onChange={(e) => setcontainerId(e)}></TextField>
                    <InlineStack>
                        {feedData && <Button onClick={() => handleCopyClick(JSON.stringify(feedData, null, 2))}>Copy Data</Button>}
                        {json_error && <Button onClick={() => handleCopyClick(JSON.stringify(json_error, null, 2))}>Copy Error</Button>}
                    </InlineStack>


                    {feedData && <BlockStack gap={'100'}>
                        <Text as='p' tone='success'>Feed Data</Text>
                        <ReactJson collapsed={true} src={feedData} theme={"monokai"} />
                    </BlockStack>}
                    {json_error && <BlockStack gap={'100'}>
                        <Text fontWeight='bold' variant='headingMd' tone='critical' as='p'>Error</Text>
                        <ReactJson collapsed={true} src={json_error} theme={'bespin'} />
                    </BlockStack>}

                </BlockStack>
            </Card>
        </Modal >
    )
})


const RenderModal = React.memo((Props: any) => {
    let { selectedRowKeys } = Props;
    const [container_id, setcontainerId] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const [feedData, setFeedData] = useState<any>()
    const [json_error, setJSONError] = useState<any>()
    // console.log(selectedRowKeys, "xdcfvgbhn");
    useEffect(() => {
        setcontainerId(Props.selectedRowKeys.length > 0 ? Props.selectedRowKeys.toString() : '')
    }, [selectedRowKeys])


    const reset = () => {
        setLoading(false);
        setFeedData(undefined)
        setJSONError(undefined)

    }

    const handleCopyClick = (Data: any) => {
        navigator.clipboard.writeText(Data)
            .then(() => {
                Props.success('Data copied to clipboard!');
            })
            .catch((err) => {
                Props.error("Failed to copy")
                console.error('Failed to copy text: ', err);
            });
    };



    const getFeedData = () => {
        if (container_id.length < 0) {
            Props.error("Please provide source product id")
        } else {
            setLoading(true)
            let payload: any = {
                "target": {
                    "marketplace": Props?.redux?.current?.target?.marketplace,
                    "shopId": Props?.redux?.current?.target?.['_id']
                },
                "source": {
                    "marketplace": Props?.redux?.current?.source?.marketplace,
                    "shopId": Props?.redux?.current?.source?.['_id']
                },
                "source_product_ids": container_id.split(","),
                "activePage": 1,
                "return_feed": true,
                "useRefinProduct": true
            };
            Props.di.POST("amazon/product/getFeedView", payload).then((data: any) => {
                setLoading(false);
                if (data.success) {
                    setFeedData(data?.data);
                    setJSONError(data?.jsonProductErrorList)
                } else {
                    setJSONError(data?.jsonProductErrorList)
                    Props.error(data?.message)
                }

            })
        }


    }
    return (
        <Modal
            open={Props?.feedmodal}
            onClose={() => {
                reset()
                Props.setFeedmodal(false);
            }}
            title={"View Feed Data"}
            primaryAction={{
                content: 'Proceed',
                onAction: () => getFeedData(),
                loading: loading
            }}
        >
            <Card roundedAbove='sm'>
                <BlockStack gap={'300'}>
                    <TextField placeholder='source product id' autoComplete="off" label='Provide source product id ' value={container_id} onChange={(e) => setcontainerId(e)}></TextField>
                    <InlineStack>
                        {feedData && <Button onClick={() => handleCopyClick(JSON.stringify(feedData, null, 2))}>Copy Data</Button>}
                        {json_error && <Button onClick={() => handleCopyClick(JSON.stringify(json_error, null, 2))}>Copy Error</Button>}
                    </InlineStack>


                    {feedData && <BlockStack gap={'100'}>
                        <Text as='p' tone='success'>Feed Data</Text>
                        <ReactJson collapsed={true} src={feedData} theme={"monokai"} />
                    </BlockStack>}
                    {json_error && <BlockStack gap={'100'}>
                        <Text fontWeight='bold' variant='headingMd' tone='critical' as='p'>Error</Text>
                        <ReactJson collapsed={true} src={json_error} theme={'bespin'} />
                    </BlockStack>}

                </BlockStack>
            </Card>
        </Modal >
    )
})

const RenderLabelAssignmentModal = React.memo((Props: any) => {
    const { labelModal, setLabelModal } = Props;
    const [requiredDetails, setRequiredDetails] = useState<string>("");
    const [errors, setErrors] = useState<any>({
        file: false,
        requiredDetails: false,
        labels: false
    })
    const [requiredDetailsError, setrequiredDetailsError] = useState<boolean>(false);
    const [allLabels, setAllLabels] = useState<any>([]);
    const [checked, setChecked] = useState<any>([]);
    const [files, setFiles] = useState<File[]>([]);
    const [loader, setLoader] = useState<boolean>(false);

    useEffect(() => {
        Props.di.GET("shopifyhome/request/getLabels", { count: true })
            .then((res: any) => {
                if (res?.success) {
                    setAllLabels(res?.data ?? []);
                }
                // else {
                //     Props.error("Labels not found.");
                // }
            });
    }, []);

    const handleChange = (change: boolean, newValue: string) => {
        setRequiredDetails(newValue);
        setErrors((prevErr: any) => {
            return {
                ...prevErr,
                requiredDetails: false
            }
        })
    }

    const handleCheckboxChange = (id: string) => {
        let tempCheckboxes = [...checked];
        if (tempCheckboxes.includes(id)) tempCheckboxes.splice(tempCheckboxes.indexOf(id), 1);
        else tempCheckboxes.push(id);
        setChecked(tempCheckboxes);
        if (tempCheckboxes?.length == 0) setErrors((prevErr: any) => {
            return {
                ...prevErr,
                labels: true
            }
        });
        else {
            setErrors((prevErr: any) => {
                return {
                    ...prevErr,
                    labels: false
                }
            });
        }
    }

    const validFileTypes = ['text/csv'];

    const handleDropZoneDrop = useCallback(
        (_dropFiles: File[], acceptedFiles: File[], _rejectedFiles: File[]) => {
            if (validFileTypes.includes(acceptedFiles[0].type)) {
                setErrors((prevErr: any) => {
                    return {
                        ...prevErr,
                        file: false
                    }
                })
                setFiles(acceptedFiles);
            } else {
                Props.error('Please Select xlsx file to Upload');
            }
        },
        [],
    );

    const uploadedFiles = files.length > 0 && <BlockStack gap="200">
        <Text as="span" fontWeight="semibold">
            Added File :
        </Text>
        <Divider borderWidth="050" />
        <div className="custom-replace-section">
            <InlineStack
                align="space-between"
                blockAlign="center"
                gap="400">
                <InlineStack blockAlign="center" gap="400">
                    <Thumbnail
                        size="small"
                        alt={files[0].name}
                        source={NoteMinor}
                    />
                    <BlockStack inlineAlign="center">
                        <Text as="span" fontWeight="semibold">
                            {files[0].name}
                        </Text>
                    </BlockStack>
                </InlineStack>
                <Button
                    onClick={() => {
                        setFiles([]);
                    }}>
                    Replace
                </Button>
            </InlineStack>
        </div>
        <Divider borderWidth="050" />
    </BlockStack>

    const fileTitle: any = <Icon source={AddMajor} />;
    const fileUpload = !files.length && <DropZone.FileUpload actionHint={`Add/Drag CSV file here`} actionTitle={fileTitle} />;

    function prepareheaders() {
        return {
            Authorization:
                'Bearer ' + Props.di.globalState.getBearerToken(),
            appCode: btoa(JSON.stringify(environment.appCode)),
            appTag: environment.appTag,
            'Ced-Source-Id': Props?.redux?.current?.source?._id,
            'Ced-Source-Name': Props?.redux?.current?.source?.marketplace,
            'Ced-Target-Id': Props?.redux?.current?.target?._id,
            'Ced-Target-Name': Props?.redux?.current?.target?.marketplace,
        };
    }

    const getAssignedLabels = () => {
        const result = allLabels.filter((item: any) =>
            checked.some((id: any) => id === item.id)
        ).map(({ id, name }: any) => ({ id, name }));
        return result;
    }

    const validator = () => {
        let hasError: boolean = false;
        let tempErr = JSON.parse(JSON.stringify(errors));
        if (files?.length == 0) {
            tempErr['file'] = true;
            if (!hasError) hasError = true;
        }
        else if (requiredDetails == "") {
            tempErr['requiredDetails'] = true;
            if (!hasError) hasError = true;
        }
        else if (checked?.length == 0) {
            tempErr['labels'] = true;
            if (!hasError) hasError = true;
        }

        return { hasError, tempErr }
    }

    const handleImport = () => {
        const { hasError, tempErr } = validator();
        if (hasError) {
            setErrors(JSON.parse(JSON.stringify(tempErr)));
            Props.error("Some information is missing or wrong, kindly check them before proceeding.");
        }
        else {
            if (files.length > 0) {
                setLoader(true);
                const formData = new FormData();
                const url = `${environment.API_ENDPOINT}shopifyhome/request/startBulkLabelAssignment`;

                formData.append('file', files[0]);
                formData.append('unique_identifier', requiredDetails);
                formData.append('assigned_labels', JSON.stringify(getAssignedLabels() ?? []));

                fetch(url, {
                    headers: { ...prepareheaders() },
                    method: 'POST',
                    body: formData,
                })
                    .then((response: any) => response.json())
                    .then((data) => {
                        setFiles([])
                        if (data.success) {
                            Props.success(data.message);
                        } else {
                            Props.error(data.message);
                        }
                        setLoader(false);
                        setLabelModal(false);
                    })
                    .catch((error) => {
                        setLoader(false);
                        console.error('Error:', error); // Log the error details for debugging
                        Props.error('Something Went Wrong');
                    });
            }
            else Props.error("Please choose file to import.")
        }
    }

    const handleModalClose = () => {
        setLabelModal(false);
        setRequiredDetails("");
        setChecked([]);
        setFiles([]);
    }

    return <>
        {allLabels?.length == 0 ?
            <Modal open={labelModal} onClose={handleModalClose} title="Bulk Label Assignment">
                <Modal.Section>
                    <BlockStack>
                        <Banner>
                            <Text as='p' fontWeight='bold'>No labels found. Kindly go to settings section and create labels.</Text>
                        </Banner>
                    </BlockStack>
                </Modal.Section>
            </Modal> :
            <Modal open={labelModal} title="Bulk Label Assignment" primaryAction={allLabels?.length == 0 ? {} : { content: "Import", onAction: handleImport, loading: loader }} secondaryActions={allLabels?.length == 0 ? [] : [{ content: "Cancel", disabled: loader, onAction: handleModalClose }]} onClose={handleModalClose}>
                <Modal.Section>
                    {allLabels?.length == 0 ? <BlockStack>
                        <Text as='p' fontWeight='bold'>No labels found. Kindly go to settings section and create labels.</Text>
                    </BlockStack> :
                        <BlockStack gap={"400"}>
                            <BlockStack gap={"300"}>
                                {files.length == 0 && <DropZone onDrop={handleDropZoneDrop} allowMultiple={false}>
                                    {fileUpload}
                                </DropZone>}
                                {uploadedFiles}
                                {errors['file'] && <InlineError message={"Choose file before importing."} fieldID='fileErr' />}
                            </BlockStack>
                            <div className={errors['requiredDetails'] ? 'custom-error-description' : ''}>
                                <Card background='bg'>
                                    <BlockStack gap="200">
                                        <Text as='p' variant='bodyMd' fontWeight='medium'>Please select the required details before import</Text>
                                        <InlineGrid columns={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3 }} gap={"200"}>
                                            <RadioButton
                                                label="SKU"
                                                checked={requiredDetails == 'sku'}
                                                name="sku"
                                                id='sku'
                                                onChange={handleChange}
                                            />
                                            <RadioButton
                                                label="Handle"
                                                name="handle"
                                                id='handle'
                                                checked={requiredDetails == 'handle'}
                                                onChange={handleChange}
                                            />
                                            <RadioButton
                                                label="Title"
                                                name="title"
                                                id='title'
                                                checked={requiredDetails == 'title'}
                                                onChange={handleChange}
                                            />
                                            <RadioButton
                                                label="Barcode"
                                                name="barcode"
                                                id='barcode'
                                                checked={requiredDetails == 'barcode'}
                                                onChange={handleChange}
                                            />
                                        </InlineGrid>
                                    </BlockStack>
                                </Card>
                            </div>
                            <Card background='bg'>
                                <BlockStack gap="200">
                                    <Text as='p' variant='bodyMd' fontWeight='medium'>Select Labels</Text>
                                    <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} gap={"200"}>
                                        {
                                            allLabels.map((item: any, ind: number) => {
                                                return (
                                                    <Checkbox label={item.name} key={ind} checked={checked.includes(item.id)} onChange={() => handleCheckboxChange(item.id)} />
                                                )
                                            })
                                        }
                                    </InlineGrid>
                                    {errors['labels'] && <InlineError fieldID='labelsErr' message={"You can't proceed without selecting labels."} />}
                                </BlockStack>
                            </Card>
                        </BlockStack>
                    }
                </Modal.Section>
            </Modal >}
    </>
})

export default React.memo(Adminactions);